//by Tiago Salteiro

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/nav.css";

const token = localStorage.getItem("accessToken");
const API_BASE_URL = process.env.REACT_APP_BE_BASE_URL;

const headersAuth = {
  Authorization: `Bearer ${token}`,
};

const Nav = React.memo(() => {
  const navigate = useNavigate();

  interface dataFetched {
    firstName: string;
    imageUrl: string;
    role: string;
  }

  const [elements, setElements] = useState<dataFetched>();

  const [isOpen, setIsOpen] = useState(false);

  function logOut() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("permissions");
    navigate("/Login");
  }

  function editProfile() {
    navigate("/Profile");
  }

  //Get image and firstName
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user/nav`, {
          headers: headersAuth,
        });
        const data = await response.json();

        // Only set state if data has changed
        setElements((prev) =>
          prev
            ? JSON.stringify(prev) !== JSON.stringify(data)
              ? data
              : prev
            : data
        );
      } catch (error) {
        console.error("Error in fetching data:", error);
      }
    };
    if (token) {
      fetchData();
    }
  }, []);

  // Memoize elements for performance, no need to re-render if elements haven't changed
  const userElements = useMemo(() => elements, [elements]);

  return (
    <>
      <div className="right-section">
        <div className="nav">
          <div className="profile">
            <div className="info">
              <p>
                Olá, <b>{userElements?.firstName}</b>
              </p>
              <small className="text-muted">{userElements?.role}</small>
            </div>
            <div className="profile-photo">
              <img src={userElements?.imageUrl} alt="profile-pic" />
            </div>
          </div>

          <div className="drop-down">
            <button
              id="menu-btn"
              onClick={() => setIsOpen(!isOpen)}
              className="menu-btn"
            >
              <span className="material-symbols-outlined menu">menu</span>
            </button>

            {isOpen && (
              <div className="dropdown-menu">
                <button onClick={editProfile}>
                  <span className="material-symbols-outlined">person</span>
                  <h3>Perfil</h3>
                </button>
                <button onClick={logOut} className="logout">
                  <span className="material-symbols-outlined">logout</span>
                  <h3>Finalizar sessão</h3>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default Nav;
